/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumera los campos que pueden editarse de una reserva.
 */
export type ReservaPatchFieldsEnum = 'nuevoEstado' | 'addMovimientos' | 'statusMovimientos' | 'personas' | 'comentario' | 'responsable';

export const ReservaPatchFieldsEnum = {
    NuevoEstado: 'nuevoEstado' as ReservaPatchFieldsEnum,
    AddMovimientos: 'addMovimientos' as ReservaPatchFieldsEnum,
    StatusMovimientos: 'statusMovimientos' as ReservaPatchFieldsEnum,
    Personas: 'personas' as ReservaPatchFieldsEnum,
    Comentario: 'comentario' as ReservaPatchFieldsEnum,
    Responsable: 'responsable' as ReservaPatchFieldsEnum
};

